module.exports = __webpack_public_path__ + "img/360.ebb36d14.png";